document.addEventListener('DOMContentLoaded', () => {
	listener('change', "#typesize", (el, e) =>  {
		Turbo.visit(el.value);
	});
});
